module.exports = __webpack_public_path__ + "static/img/ZN_Esports_Logo_white.daa12706.png";